import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
    selector: 'app-admin',
    templateUrl: './admin.component.html',
    encapsulation: ViewEncapsulation.None
})

export class AdminComponent implements OnInit {

    isUserLoggedIn = false;

    constructor(
        private authService: AuthService,
        private router: Router) { }

    ngOnInit(): void {
        let storeData = localStorage.getItem("isUserLoggedIn");
        console.log("StoreData: " + storeData);

        if (storeData != null && storeData == "true")
            this.isUserLoggedIn = true;
        else
            this.isUserLoggedIn = false;
    }

    logout(): void {
        this.authService.logout();
        this.router.navigate(['/login']);
    }
}
